<template>
  <v-card class="mt-3 rounded-card card-shadow">
    <v-card-text class="text--primary">
      <v-row dense>
        <v-col cols="12" v-if="isMoedaEstrangeira">
          <px-moeda-chip :moeda="moeda"/>
        </v-col>
        <v-col cols="12" sm="4">
          <template v-if="isMoedaEstrangeira">
            <v-row dense no-gutters class="body-1">
              <v-col cols="6">
                Produtos:
              </v-col>
              <v-col cols="6" class="text-right">
                {{
                  compra.totalProdutos |
                    currency(simboloMoeda, casaDecimal, configuracaoFormatacaoMoeda)
                }}
              </v-col>
              <v-col cols="6">
                Frete:
              </v-col>
              <v-col cols="6" class="text-right">
                {{
                  compra.frete.totalTransporte |
                    currency(simboloMoeda, 2, configuracaoFormatacaoMoeda)
                }}
              </v-col>
              <v-col cols="6" class="font-weight-bold">
                Total:
              </v-col>
              <v-col cols="6" class="text-right">
                  <span class="text--primary--color font-weight-bold">
                    {{
                      compra.total |
                        currency(simboloMoeda, casaDecimal, configuracaoFormatacaoMoeda)
                    }}
                  </span>
              </v-col>
              <template v-if="isMoedaEstrangeira && compra.saving">
                <v-col cols="6" class="font-weight-bold">
                  Saving:
                </v-col>
                <v-col cols="6" class="text-right">
                      <span class="text--success--color font-weight-bold">
                        {{
                          compra.saving |
                            currency(simboloMoeda, 2, configuracaoFormatacaoMoeda)
                        }}
                      </span>
                </v-col>
              </template>
            </v-row>
          </template>
        </v-col>
        <v-col cols="12" sm="4"></v-col>
        <v-col cols="12" sm="4">
          <v-row dense no-gutters class="body-1">
            <v-col cols="6">
              Produtos:
            </v-col>
            <v-col cols="6" class="text-right">
              {{ compra.valorMoedaConvertido.totalProdutos | currency('R$', casaDecimal) }}
            </v-col>
            <v-col cols="6">
              Frete:
            </v-col>
            <v-col cols="6" class="text-right">
              {{ compra.frete.totalTransporteConvertido | currency }}
            </v-col>
            <v-col cols="6" class="font-weight-bold">
              Total:
            </v-col>
            <v-col cols="6" class="text-right">
                  <span class="text--primary--color font-weight-bold">
                    {{ compra.valorMoedaConvertido.total | currency('R$', casaDecimal) }}
                  </span>
            </v-col>
            <template v-if="compra.saving">
              <v-col cols="6" class="font-weight-bold">
                Saving:
              </v-col>
              <v-col cols="6" class="text-right">
                      <span class="text--success--color font-weight-bold">
                        {{ compra.valorMoedaConvertido.saving | currency }}
                      </span>
              </v-col>
            </template>
          </v-row>
        </v-col>
      </v-row>
      <v-data-table
        show-expand
        hide-default-footer
        disable-pagination
        :headers="headers"
        :items="sortedProdutos"
        item-key="id"
        class="elevation-0 mt-3"
      >
        <template v-slot:item.descricao="{ item }">
          <px-entrega-menu
            v-if="hasControleEntrega && !isRecusadoCancelado && !isItemCancelado(item)"
            :item="item"
            :has-role-gestor-entrega="hasRoleGestorEntrega"
            @change-data-entrega="updatePrevisaoEntrega"
            @change-entrega="finalizarEntrega">
            <template v-slot:activator="{ on }">
              <px-situacao-entrega-compra-icon v-on="on"
                                               :situacao="item.situacaoEntrega"/>
            </template>
          </px-entrega-menu>
          <px-produto-descricao
            :especificacao="item.especificacaoProdutoOrigem || item.especificacaoProduto"
            :produto="item.produto"/>&nbsp;
          <px-historico-preco-produto small
                                      :produto="item.produto"
                                      :unidade-medida="item.unidadeMedida"/>
          <px-anexo v-if="item.arquivos && item.arquivos.length"
                    small read-only dot
                    v-model="item.arquivos"
                    download-base-path="files/download-comprador">
            <template v-slot:activator="{ on }">
              <v-btn small icon
                     v-on="on">
                <v-icon small>mdi-paperclip</v-icon>
              </v-btn>
            </template>
          </px-anexo>
          <px-show-is-homologado small
                                 :produto="item.produto"
                                 :id-fornecedor="compra.fornecedor.id"/>
          <v-chip label small v-if="isItemCancelado(item)"
                  class="ml-2"
                  color="error">
            Cancelado
          </v-chip>
        </template>
        <template v-slot:item.quantidade="{ item }">
          <span>
            {{ item.quantidade | number(getCurrencyFormat(item.produto.casasDecimais)) }}&nbsp;
          {{ item.unidadeMedida.descricao }}
          </span>
        </template>
        <template v-slot:item.precoUnitario="{ item }">
          <div>
            {{
              item.valorMoedaConvertido.precoUnitario
                | currency('R$', item.produto.casasDecimais)
            }}
            <div class="caption" v-if="isMoedaEstrangeira">
              {{
                item.precoUnitario
                  | currency(simboloMoeda,
                  item.produto.casasDecimais,
                  configuracaoFormatacaoMoeda)
              }}
            </div>
          </div>
        </template>
        <template v-slot:item.icms="{ item }">
          <px-imposto
            :imposto="item.impostos"
            show-valor-convertido
            tipo="ICMS"
            :show-aplicacao="false"
            :scale="item.produto.casasDecimais"/>
          <div v-if="isMoedaEstrangeira">
            <px-imposto
              class="caption"
              :imposto="item.impostos"
              :simbolo-moeda="simboloMoeda"
              :configuracao-moeda="configuracaoFormatacaoMoeda"
              tipo="ICMS"
              :show-aplicacao="false"
              :scale="item.produto.casasDecimais"/>
          </div>
        </template>
        <template v-slot:item.ipi="{ item }">
          <px-imposto
            show-valor-convertido
            :imposto="item.impostos"
            tipo="IPI"
            :show-aplicacao="false"
            :scale="item.produto.casasDecimais"/>
          <div v-if="isMoedaEstrangeira">
            <px-imposto
              class="caption"
              :imposto="item.impostos"
              :simbolo-moeda="simboloMoeda"
              :configuracao-moeda="configuracaoFormatacaoMoeda"
              tipo="IPI"
              :show-aplicacao="false"
              :scale="item.produto.casasDecimais"/>
          </div>
        </template>
        <template v-slot:item.total="{ item }">
          <div>
            {{ item.valorMoedaConvertido.total | currency('R$', item.produto.casasDecimais) }}
            <div class="caption" v-if="isMoedaEstrangeira">
              {{
                item.total
                  | currency(simboloMoeda,
                  item.produto.casasDecimais,
                  configuracaoFormatacaoMoeda)
              }}
            </div>
          </div>
          <px-situacao-cotacao-produto :situacao="item.situacao"/>
        </template>
        <template v-slot:item.options="{ item }">
          <px-compra-item-menu-options v-if="!isItemCancelado(item) && showItemMenuOptions"
                                       :item-compra="item"
                                       @update="onUpdate"/>
          <v-tooltip top>
            <template v-if="isFromCotacao" v-slot:activator="{ on }">
              <px-resposta-detalhes-dialog-view
                :cotacao-id="item.respostaCotacaoProduto.respostaCotacao.cotacao.id"
                :resposta-id="item.respostaCotacaoProduto.respostaCotacao.id"
              />
              <v-btn v-on="on" icon link target="_blank" :to="linkCotacao(item)">
                <v-icon>mdi-open-in-new</v-icon>
              </v-btn>
            </template>
            <span>Ir para a cotação</span>
          </v-tooltip>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="grey lighten-4 expanded-item">
            <v-row dense class="pa-3">
              <v-col cols="12" sm="4" v-if="showCodigoInterno">
                <span class="caption font-weight-bold">Código da OC</span>
                <div>
                  {{ item.codigoInterno | naoInformado }}
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <span class="caption font-weight-bold">Código de referência Fornecedor</span>
                <div>
                  {{ codigoReferencia(item.produto) | naoInformado }}
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <span class="caption font-weight-bold">Data de faturamento</span>
                <div>
                  {{ item.dataFaturamento | date | naoInformado }}
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <span class="caption font-weight-bold">Prazo de entrega solicitado</span>
                <div>
                  {{ item.dataPrevisaoEntrega | date }}
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <span class="caption font-weight-bold">Observação externa do produto</span>
                <div>
                  <px-show-large-text :large-text="observacaoExterna(item)"/>
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <span class="caption font-weight-bold">Observação interna do produto</span>
                <div>
                  <px-show-large-text :large-text="observacaoInterna(item)"/>
                </div>
              </v-col>
              <v-col cols="12" sm="4" v-if="isFromCotacao">
                <span class="caption font-weight-bold">Especificação cotada</span>
                <div>
                  <px-show-large-text :large-text="item.especificacaoProdutoOrigem"/>
                </div>
              </v-col>
              <v-col cols="12" sm="4" v-if="item.especificacaoProduto">
                <span class="caption font-weight-bold">{{ labelEspecificacaoProduto }}</span>
                <div>
                  <px-show-large-text :large-text="item.especificacaoProduto"/>
                </div>
              </v-col>
              <v-col cols="12" sm="4">
                <span class="caption font-weight-bold">Finalidade da compra</span>
                <div v-if="item.finalidadeCompra">
                  <px-finalidade-compra-value :finalidade-compra="item.finalidadeCompra"/>
                </div>
                <div v-else>
                  Não informado
                </div>
              </v-col>
              <v-col cols="12" sm="4" v-if="checkPrecoTarget(item)">
                <span class="caption font-weight-bold">Preço Target</span>
                <div>
                  {{ item.produto.precoTarget | currency('R$', getCasaDecimalItem(item)) }}
                </div>
              </v-col>
              <v-col cols="12" sm="4" v-if="item.centroCusto && showCentroCusto">
                <span class="caption font-weight-bold">Centro de custo</span>
                <div>
                  {{ centroCusto(item.centroCusto) | truncate(45) }}
                </div>
              </v-col>
              <v-col cols="12" sm="4" v-if="item.projeto">
                <span class="caption font-weight-bold">Projeto</span>
                <div>
                  {{ projeto(item.projeto) | truncate(45) }}
                </div>
              </v-col>
              <v-col cols="12" sm="4" v-if="item.tipoNotaEntrada">
                <span class="caption font-weight-bold">Tipo de nota de entrada do produto</span>
                <div>
                  <px-span-tooltip top
                                   :text="notaEntrada(item.tipoNotaEntrada)"
                                   :tooltip="item.tipoNotaEntrada.descricao"/>
                </div>
              </v-col>
              <v-col cols="12" sm="4" v-if="item.cfop">
                <span class="caption font-weight-bold">CFOP do produto</span>
                <div>
                  <px-span-tooltip top
                                   :text="cfop(item.cfop)"
                                   :tooltip="`${item.cfop.codigo} - ${item.cfop.descricao}`"/>
                </div>
              </v-col>
              <v-col cols="12" sm="4"
                    v-if="item.arquivos && item.arquivos.length">
                <span class="caption font-weight-bold">Arquivos do comprador</span>
                <px-anexo-chip :files="item.arquivos"
                               download-base-path="files/download-comprador"/>
              </v-col>
              <v-col cols="12" sm="4"
                    v-if="item.respostaCotacaoProduto
                    && item.respostaCotacaoProduto.arquivos
                    && item.respostaCotacaoProduto.arquivos.length">
                <span class="caption font-weight-bold">Arquivos do fornecedor</span>
                <px-anexo-chip :files="item.respostaCotacaoProduto.arquivos"
                               download-base-path="files/download-fornecedor"/>
              </v-col>
              <v-col cols="12" sm="4" v-if="item.impostos.valorDifalConvertido">
                <span class="caption font-weight-bold">Valor total DIFAL</span>
                <div>
                  {{ item.impostos.valorDifalConvertido
                   | currency('R$', casaDecimal) }}
                </div>
              </v-col>
              <v-col cols="12" sm="4" v-if="isItemCancelado(item)">
                <span class="caption font-weight-bold">Motivo da recusa/cancelamento</span>
                <div>
                  <px-show-large-text :large-text="motivoRecusa(item)"/>
                </div>
              </v-col>
            </v-row>
            <px-campos-integracao v-if="cadastrosAdicionaisItem(item)"
                                  type="compra-produtos-view"
                                  :form-data="cadastrosAdicionaisItem(item)"/>
          </td>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from 'vue';
import {
  OrigemCompra,
  SituacaoCompra,
  SituacaoEntregaCompra,
  SituacaoItemCompra,
} from 'px-business-components';
import { CasaDecimalUtils, FornecedorProdutoUtils } from 'px-components';
import CompraProdutoService from '@/modules/compra/compra-produto-service';
import { sortBy } from 'lodash';
import { mapGetters } from 'vuex';
import { cadastrosAdicionaisToMap } from '@/utils/campos-integracao-utils';
import { getPrecision } from '@/utils/produto-utils';
import { descWithCodigoInterno } from '@/utils/object-utils';
import moedaMixin from '@/mixins/moeda-mixin';
import RespostaDetalhesDialogView
  from '@/modules/cotacao/resposta/detalhes/RespostaDetalhesDialogView.vue';
import CompraItemMenuOptions from '@/modules/compra/detalhes/CompraItemMenuOptions.vue';
import { isFieldHiddenEntityItens } from '@/modules/erp-campos/erp-campos-utils';

export default {
  mixins: [moedaMixin],
  props: {
    compra: Object,
    camposPersonalizados: Object,
    camposHidden: Object,
  },
  data() {
    return {
      headers: [
        {
          text: 'Produto',
          sortable: false,
          value: 'descricao',
        },
        {
          text: 'Quantidade',
          value: 'quantidade',
          sortable: false,
        },
        {
          text: 'Preço unitário',
          value: 'precoUnitario',
        },
        {
          text: 'ICMS',
          value: 'icms',
          sortable: false,
        },
        {
          text: 'IPI',
          value: 'ipi',
          sortable: false,
        },
        {
          text: 'Total',
          value: 'total',
        },
        {
          text: '',
          value: 'options',
          align: 'end',
        },
        {
          text: '',
          value: 'data-table-expand',
        },
      ],
    };
  },
  computed: {
    ...mapGetters('user', ['hasRoleGestorEntrega']),
    ...mapGetters('entidade', ['hasControleEntrega']),
    moeda() {
      return this.compra.moeda;
    },
    cfop() {
      return cfop => `${cfop.codigo} - ${Vue.filter('truncate')(cfop.descricao, 20)}`;
    },
    notaEntrada() {
      return notaEntrada => Vue.filter('truncate')(notaEntrada.descricao, 20);
    },
    isFromCotacao() {
      return this.compra.origemCompra === OrigemCompra.keys.COTACAO.key;
    },
    linkCotacao() {
      return item => `/cotacao/${item.respostaCotacaoProduto.respostaCotacao.cotacao.id}/respostas/${item.respostaCotacaoProduto.respostaCotacao.id}`;
    },
    getCurrencyFormat() {
      return item => CasaDecimalUtils.getCurrencyFormat(item);
    },
    casaDecimal() {
      const mappedProdutos = this.compra.produtos.map(produto => produto.produto);
      return CasaDecimalUtils.getCasaDecimal(mappedProdutos);
    },
    getCasaDecimalItem() {
      return item => getPrecision(item.produto);
    },
    sortedProdutos() {
      return sortBy(this.compra.produtos, 'id');
    },
    cadastrosAdicionaisItem() {
      return (item) => {
        if (!item.cadastrosAdicionais || !item.cadastrosAdicionais.length) {
          return null;
        }
        return cadastrosAdicionaisToMap(item.cadastrosAdicionais);
      };
    },
    observacaoInterna() {
      return (produto) => {
        if (produto.observacaoInterna) {
          return produto.observacaoInterna;
        }
        return produto.produto.observacaoInterna;
      };
    },
    observacaoExterna() {
      return (produto) => {
        if (produto.observacaoExterna) {
          return produto.observacaoExterna;
        }
        return produto.produto.observacaoExterna;
      };
    },
    projeto() {
      return projeto => descWithCodigoInterno(projeto);
    },
    centroCusto() {
      return centroCusto => descWithCodigoInterno(centroCusto);
    },
    labelEspecificacaoProduto() {
      return this.isFromCotacao ? 'Especificação do fornecedor' : 'Especificação do produto';
    },
    isRecusadoCancelado() {
      return this.compra.situacao === SituacaoCompra.keys.RECUSADA.key
        || this.compra.situacao === SituacaoCompra.keys.CANCELADA.key;
    },
    checkPrecoTarget() {
      return item => item.produto.precoTarget && item.produto.precoTarget > 0;
    },
    isItemCancelado() {
      return item => item.situacao === SituacaoItemCompra.keys.CANCELADO.key;
    },
    showItemMenuOptions() {
      return ![SituacaoCompra.keys.AGUARDANDO_APROVACAO_INTERNA.key].includes(this.compra.situacao);
    },
    codigoReferencia() {
      return (produto) => {
        const { fornecedoresProduto } = produto;
        return FornecedorProdutoUtils
          .getCodigoReferenciaFornecedor(fornecedoresProduto, this.compra.fornecedor.id);
      };
    },
    showCodigoInterno() {
      return this.camposPersonalizados?.codigoInterno.visivel || false;
    },
    showCentroCusto() {
      return !isFieldHiddenEntityItens('centroCusto', this.camposHidden);
    },
    motivoRecusa() {
      return (item) => {
        if (item.motivoRecusa) {
          return item.motivoRecusa;
        }
        return this.compra.motivoRecusa;
      };
    },
  },
  methods: {
    updatePrevisaoEntrega(item, dataPrevisao) {
      CompraProdutoService.updatePrevisaoEntregaProduto(this.compra.id, item.id, {
        dataPrevisaoEntrega: dataPrevisao,
      }).then(() => {
        this.$toast('Data de entrega atualizada', { color: 'success' });
      });
    },
    finalizarEntrega(item) {
      CompraProdutoService.finalizarEntregaProduto(this.compra.id, item.id).then(() => {
        // eslint-disable-next-line no-param-reassign
        item.situacaoEntrega = SituacaoEntregaCompra.keys.ENTREGUE.key;
        this.$toast('Compra atualizada', { color: 'success' });
      });
    },
    onUpdate() {
      this.$emit('update');
    },
  },
  components: {
    pxRespostaDetalhesDialogView: RespostaDetalhesDialogView,
    pxCompraItemMenuOptions: CompraItemMenuOptions,
  },
};
</script>
